import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminFrontendUsersFrontendUserRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ frontend_user_id }) {
    const { content } = await this.store.request(
      findRecord('frontend-user', frontend_user_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
